'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const tslib = require('tslib');
const MotionConfigContext = require('../../context/MotionConfigContext.js');
const PresenceContext = require('../../context/PresenceContext.js');
const useConstant = require('../../utils/use-constant.js');
const usePresence = require('../../components/AnimatePresence/use-presence.js');
const LayoutGroupContext = require('../../context/LayoutGroupContext.js');
const index = require('../../context/MotionContext/index.js');
const useIsomorphicEffect = require('../../utils/use-isomorphic-effect.js');
const useSnapshotOnUnmount = require('../features/layout/use-snapshot-on-unmount.js');

function useLayoutId(_a) {
  var layoutId = _a.layoutId;
  var layoutGroupId = React.useContext(LayoutGroupContext.LayoutGroupContext);
  return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function useVisualElement(isStatic, visualState, createVisualElement, props) {
  var config = React.useContext(MotionConfigContext.MotionConfigContext);
  var parent = index.useVisualElementContext();
  var presenceContext = React.useContext(PresenceContext.PresenceContext);
  var layoutId = useLayoutId(props);
  var visualElement = useConstant.useConstant(function () {
    return createVisualElement(isStatic, {
      visualState: visualState,
      parent: parent,
      props: tslib.__assign(tslib.__assign({}, props), {
        layoutId: layoutId
      }),
      presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
      blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false
    });
  });
  useIsomorphicEffect.useIsomorphicLayoutEffect(function () {
    visualElement.setProps(tslib.__assign(tslib.__assign(tslib.__assign({}, config), props), {
      layoutId: layoutId
    }));
    visualElement.isPresent = usePresence.isPresent(presenceContext);
    visualElement.isPresenceRoot = !parent || parent.presenceId !== (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id);
    /**
     * Fire a render to ensure the latest state is reflected on-screen.
     */
    visualElement.syncRender();
  });
  React.useEffect(function () {
    var _a;
    /**
     * In a future refactor we can replace the features-as-components and
     * have this loop through them all firing "effect" listeners
     */
    (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.animateChanges();
  });
  /**
   * If this component is a child of AnimateSharedLayout, we need to snapshot the component
   * before it's unmounted. This lives here rather than in features/layout/Measure because
   * as a child component its unmount effect runs after this component has been unmounted.
   */
  useSnapshotOnUnmount.useSnapshotOnUnmount(visualElement);
  return visualElement;
}

exports.useVisualElement = useVisualElement;
